var map = {
	"./KB.png": "120b",
	"./about_us_banner.gif": "1395",
	"./adminHeader.png": "ac2a",
	"./annualBack.png": "8fcc",
	"./annualFront.png": "4618",
	"./annualIntroduction.jpg": "1126",
	"./beian.png": "cc3c",
	"./bg-login.jpg": "894c4",
	"./bs.png": "4305",
	"./commentRate_1.png": "c754",
	"./commentRate_2.png": "c62b",
	"./commentRate_3.png": "f1dd",
	"./commentRate_4.png": "1a27",
	"./commentRate_5.png": "9f09",
	"./defaultImg.png": "69cf",
	"./defaultImgSmall.png": "a32b",
	"./detail-quality-2.png": "66d8",
	"./detail-quality.png": "7d1e",
	"./fangchong.ico.png": "d64d",
	"./footer_bg.jpg": "f351",
	"./guide_logo.png": "06a4",
	"./guide_logo_1.png": "9884",
	"./guoqing/70.png": "c4ea",
	"./guoqing/GQD.png": "c387",
	"./guoqing/gq0.png": "98a0",
	"./guoqing/gq1.png": "70b4",
	"./guoqing/gq11.png": "1744",
	"./guoqing/gq12.png": "b26b",
	"./guoqing/gq13.png": "69e8",
	"./guoqing/gq14.png": "9264",
	"./guoqing/gq15.png": "fe43",
	"./guoqing/gq16.png": "cc2b",
	"./guoqing/gq17.png": "638c",
	"./guoqing/gq18.png": "39e31",
	"./guoqing/gq19.png": "9aec",
	"./guoqing/gq2.jpg": "fb5a",
	"./guoqing/gq3.png": "a7bf",
	"./guoqing/gq4.png": "610e",
	"./guoqing/gq5.png": "cac0",
	"./guoqing/gq6.png": "ef6a6",
	"./guoqing/gq7.png": "9226",
	"./guoqing/gq8.png": "364b",
	"./guoqing/gq9.png": "c777",
	"./hexagon.png": "659c",
	"./hexagonHover.png": "5590",
	"./hotel-map.png": "faf7",
	"./hotel_list_banner.gif": "a3d6",
	"./hotel_rebate_logo.png": "31aa",
	"./icon-active.png": "e8be",
	"./icon.png": "4629",
	"./index_header_logo.png": "5c0d",
	"./index_order_bg.jpg": "4ea4",
	"./invoice.jpg": "6b62",
	"./left.png": "55b6",
	"./loading.svg": "e189",
	"./logo.png": "da52",
	"./logo2.png": "bea0",
	"./logo3.png": "e477",
	"./logo4.png": "142f",
	"./map.png": "90d3",
	"./map2.jpg": "3da1",
	"./map2.png": "11d1",
	"./mapClick.png": "b3eb",
	"./member_default_avatar.jpg": "3688",
	"./noComment.png": "799d",
	"./noneimg.jpg": "a759",
	"./pige/ad01.png": "74d2",
	"./pige/ad02.png": "35ab",
	"./pige/ad03.png": "5890",
	"./pige/ad04.png": "4e3f",
	"./pige/ad05.png": "ef83",
	"./pige/logo.png": "6017",
	"./pnewyear.png": "6d93",
	"./radio.png": "8cd0",
	"./right.png": "974d",
	"./rmcs_1.jpg": "838e",
	"./rmcs_2.jpg": "503d",
	"./rmcs_3.jpg": "1d3e",
	"./rmcs_4.png": "2d19",
	"./rz_1.png": "0a89",
	"./rz_2.png": "d2bb",
	"./seal.png": "b0d2",
	"./sj-0.png": "4e16",
	"./sj-1.png": "f0bd",
	"./sj-2.png": "d208",
	"./succ.png": "d303",
	"./xl_1.png": "070f",
	"./xl_2.png": "24e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3268";